import { FormHandle } from '@/hooks/use-form-handle.hook';
import { FC, useEffect } from 'react';
import InputControl from '@/components/form/input-control';
import { isWriteMode, ViewMode } from '@/lib/helpers';
import { Box } from '@mui/material';
import { PrivateModelModel } from '@/lib/models/private-model/private-model.model';
import { AwsConnectorModel } from '@/lib/models/connector/aws-connector.model';

interface Props {
  formHandle: FormHandle<PrivateModelModel>;
  mode: ViewMode;
  connector: AwsConnectorModel;
}

const AwsPrivateModel: FC<Props> = ({ formHandle, mode, connector }) => {
  const inWriteMode = isWriteMode(mode);
  const { setFieldValue } = formHandle;

  const { config } = connector;

  useEffect(() => {
    setFieldValue('provider', 'aws', false);
    setFieldValue(
      'config',
      {
        region: config.awsRegion,
      },
      false
    );
  }, [config.awsRegion, setFieldValue]);

  if (!inWriteMode) {
    return null;
  }

  return (
    <Box>
      <InputControl name="config.region" label="AWS Region" formHandle={formHandle} readonly />
    </Box>
  );
};

export default AwsPrivateModel;
